import { track } from "jiffy-analytics";
import { api } from "jiffy-api";
import { getQueryParams } from "common/utils/browser";
import ModalClass from "common/utils/ui/modal-class";
import "./digital-assets-filters-modal.scss";

export class DigitalAssetsFiltersModal extends ModalClass {
  #trustedStoriesSelector = ".js-ratingbadge";

  #placeholderSelector = ".js-assets-filters-placement";

  get #$trustedStoriesRating() {
    return document.querySelector(this.#trustedStoriesSelector);
  }

  get #$filtersPlaceholder() {
    return document.querySelector(this.#placeholderSelector);
  }

  openModalCallback() {
    super.openModalCallback();
    track("digital_asset_filter_opened", {
      page_name: this.$modal.dataset.pageName
    });
    this.#$trustedStoriesRating?.classList.add("hidden");
  }

  closeModalCallback() {
    super.closeModalCallback();
    track("digital_asset_filter_closed", {
      page_name: this.$modal.dataset.pageName
    });
    this.#$trustedStoriesRating?.classList.remove("hidden");
  }

  async loadFacets() {
    if (!this.#$filtersPlaceholder) return;

    try {
      const { html } = await api.jiffyshirts.digitalAssetsFacets({
        ...getQueryParams()
      });

      if (this.#$filtersPlaceholder) {
        this.#$filtersPlaceholder.innerHTML = html;
      }
    } catch (error) {
      throw new Error(`Error loading facets: ${error}`);
    }
  }
}

export default () =>
  new DigitalAssetsFiltersModal({
    modalSelector: "#digital-assets-filters-modal"
  });
